import React from "react";
import { Box, Typography } from "@mui/material";
import { Title } from "react-admin";
import HeroVideo from "./images/hero-restaurant-cake-pos.mp4";

const NEOWelcomePage = () => (
  <Box sx={{ padding: "20px" }}>
    <Title title="Welcome to NEO" />
    
    {/* Hero Video Background Section */}
    <Box
      sx={{
        position: "relative",
        width: "100%",
        height: "70vh",
        minHeight: "500px",
        borderRadius: "12px",
        overflow: "hidden",
        marginBottom: "20px",
        boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
      }}
    >
      {/* Background Video */}
      <video
        autoPlay
        loop
        muted
        playsInline
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          minWidth: "100%",
          minHeight: "100%",
          width: "auto",
          height: "auto",
          objectFit: "cover",
          zIndex: 0,
        }}
      >
        <source src={HeroVideo} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {/* Overlay for better text readability */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: "linear-gradient(to bottom, rgba(0,0,0,0.3), rgba(0,0,0,0.5))",
          zIndex: 1,
        }}
      />

      {/* Content Overlay */}
      <Box
        sx={{
          position: "relative",
          zIndex: 2,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "100%",
          padding: "40px",
          textAlign: "center",
          color: "white",
        }}
      >
        <Typography
          variant="h2"
          component="h1"
          gutterBottom
          sx={{
            fontWeight: "bold",
            fontSize: { xs: "2rem", md: "3.5rem" },
            lineHeight: "1.2",
            textShadow: "2px 2px 8px rgba(0,0,0,0.7)",
            marginBottom: "20px",
          }}
        >
          NEO Portal
        </Typography>
        
        <Typography
          variant="h5"
          component="p"
          sx={{
            fontSize: { xs: "1.1rem", md: "1.5rem" },
            textShadow: "1px 1px 4px rgba(0,0,0,0.7)",
            maxWidth: "600px",
            marginBottom: "30px",
          }}
        >
          Multi-Location Reporting, Integration Marketplace & Menu Administration (Coming Soon)
        </Typography>
       

        {/* You can add more content here like buttons, cards, etc. */}
      </Box>
    </Box>
  </Box>
);

export default NEOWelcomePage;